import { AltLabel } from '../../TreeViewTypes';
import { DataNode, LabelContext } from '../../data_nodes/types';
import { LabelGenerator, DefaultLabelGenerator } from '../types';

/**
 * Generate default label for Container nodes
 *
 * Containers are organizational nodes like "Milestones" that group related items
 */
export const generateContainerDefaultLabel: DefaultLabelGenerator = (
  dataNode: DataNode<any>,
  context: LabelContext,
): string => {
  const data = dataNode.data;

  // Handle container with label property
  if (data && data.label) {
    return data.label;
  }

  // Handle container with containerType
  if (data && data.containerType) {
    // Capitalize first letter
    const type = data.containerType;
    return type.charAt(0).toUpperCase() + type.slice(1);
  }

  // Fallback
  return 'Container';
};

/**
 * Generate alt labels for Container nodes
 *
 * Provides options for displaying container information in different formats
 */
export const generateContainerAltLabels: LabelGenerator = (
  dataNode: DataNode<any>,
  context: LabelContext,
): AltLabel[] => {
  const data = dataNode.data;
  const defaultLabel = generateContainerDefaultLabel(dataNode, context);

  const labels: AltLabel[] = [
    {
      key: 'default',
      selectOption: 'Default: Container name',
      value: defaultLabel,
    },
  ];

  // Add count option if container has children
  const childCount = dataNode.children?.length || 0;
  if (childCount > 0) {
    labels.push({
      key: 'with-count',
      selectOption: 'Container with item count',
      value: `${defaultLabel} (${childCount} items)`,
    });
  }

  // Add container type specific labels
  if (data && data.containerType) {
    const type = data.containerType;

    if (type === 'milestones' && childCount > 0) {
      const keyResultCount = dataNode.children?.length || 0;
      labels.push({
        key: 'milestones-count',
        selectOption: 'Milestones with key result count',
        value: `Milestones (${keyResultCount} key results)`,
      });
    }
  }

  return labels;
};
